module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="filter_button"><span class=\'checked_items\' data-title="' +
((__t = ( categoryName() )) == null ? '' : __t) +
'"></span></div>\n<ul class="filter_dropdown">\n	<div class="reset_filter none_selected"></div>\n	<div class="category_item_region"></div>\n</ul>';

}
return __p
}